export const BRAND = {
  name: "Hayat Computers and Security Solutions",
  short: "Hayat",
  tagline: "Think Security Think Hayat",
  owner: "Murtaza Hasan",
  address:
    "UG-8, Raj Commercial Complex, Walker Rd, opp. Rich Bliss Showroom, near Chitnis Park, Bhaldarpura Square, Nagpur, Maharashtra 440018, India",
  addressShort: "Bhaldarpura Square, Nagpur 440018",
  city: "Nagpur",
  sales: "9673878652",
  service: "8446255253",
  salesDisplay: "+91 96738 78652",
  serviceDisplay: "+91 84462 55253",
  email: "murtaza@hayatcctv.com",
  website: "www.hayatcctv.com",
  googleBusiness: "https://share.google/bzuK9zUSsd1tT779z",
  facebook: "https://www.facebook.com/hayatngp/",
  instagram: "https://www.instagram.com/hayat.cctv/",
  rating: 4.9,
  reviewCount: 310,
  logoUrl: "/brand/logo_horizontal.png",
  logoMark: "/brand/logo_icon.png",
};

export const WHATSAPP_LINK = (msg = "Hi, I'd like a quote for CCTV installation.") =>
  `https://wa.me/91${BRAND.sales}?text=${encodeURIComponent(msg)}`;

export const CALL_SALES = `tel:+91${BRAND.sales}`;
export const CALL_SERVICE = `tel:+91${BRAND.service}`;

export const SERVICES = [
  {
    id: "cctv",
    title: "CCTV Installation",
    short: "Dome, Bullet & PTZ cameras with mobile monitoring",
    description:
      "End-to-end installation of HD and IP cameras — Dome, Bullet and PTZ — with DVR/NVR setup, remote mobile monitoring, and neat cable management.",
    bullets: ["Dome, Bullet & PTZ cameras", "DVR / NVR setup", "Mobile monitoring app", "Clean cabling"],
    image: "https://images.pexels.com/photos/29866272/pexels-photo-29866272.jpeg",
  },
  {
    id: "networking",
    title: "Networking Solutions",
    short: "Office & home networking, cabling & router setup",
    description:
      "Structured networking for offices, retail and homes — from Cat6 cabling and patch panels to router, switch and Wi-Fi configuration that just works.",
    bullets: ["Structured cabling", "Router & switch config", "Wi-Fi coverage planning", "Labeling & documentation"],
    image: "https://images.pexels.com/photos/5073493/pexels-photo-5073493.jpeg",
  },
  {
    id: "surveillance",
    title: "Surveillance Systems",
    short: "Complete, layered security for any premises",
    description:
      "Designed surveillance — from perimeter cameras to central monitoring — tailored for shops, warehouses, showrooms, clinics and residences across Nagpur.",
    bullets: ["Site survey & design", "Multi-camera recording", "Central viewing station", "Access & alert setup"],
    image: "https://images.pexels.com/photos/30692441/pexels-photo-30692441.jpeg",
  },
  {
    id: "amc",
    title: "AMC & Maintenance",
    short: "Annual contracts, repairs & quick servicing",
    description:
      "Annual Maintenance Contracts keep your cameras and network running 365 days. Scheduled visits, priority repairs and fair pricing.",
    bullets: ["Annual maintenance plans", "Priority breakdown support", "On-site servicing", "Health & storage checks"],
    image: "https://images.pexels.com/photos/17842832/pexels-photo-17842832.jpeg",
  },
];

export const STATS = [
  { value: 15, suffix: "+", label: "Years Experience" },
  { value: 10000, suffix: "+", label: "Happy Clients" },
  { value: 12000, suffix: "+", label: "Projects Completed" },
];
